import { render } from "./AddCredentials.vue?vue&type=template&id=18ca99ed&scoped=true"
import script from "./AddCredentials.vue?vue&type=script&lang=js"
export * from "./AddCredentials.vue?vue&type=script&lang=js"

import "./AddCredentials.vue?vue&type=style&index=0&id=18ca99ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ca99ed"]])

export default __exports__